import React from 'react';
import { connect } from 'react-redux';
import { Constants, Globals } from 'utils';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { GooglePlay, AppStore, RequestQuoteFormImage, Logo } from 'assets/img';
import { WebIcon } from 'assets/icons';

interface MatchParams {
	code: string;
}

interface Props extends RootState, RouteComponentProps<MatchParams> {
	dispatch: any;
}

class Referral extends React.Component<Props> {

	state = {
		url_android: ''
	}

	componentDidMount() {
		// @ts-ignore
		const url_android = new URL(process.env.REACT_APP_ANDROID);
		url_android.searchParams.set('referrer','referral_code=' + this.props.match.params?.code);

		this.setState({
			url_android
		});
	}

	next = () => {
		if (!this.props.user && this.props.match.params?.code != null) {
			this.props.dispatch({
				type: 'SET_REFERRAL_CODE',
				payload: this.props.match.params?.code
			});
		}
		this.props.history.replace('/client/quotes/request');
	}

	render() {
		const { url_android } = this.state;

		return (
			<div id="referral">
				<h3>¡Tenemos una gran noticia! te han invitado a probar los servicios de limpieza de Servizi</h3>
				<div className="row">
					<div className="col-md-6 text-center">
						<img src={ RequestQuoteFormImage } className="image" />
					</div>
					<div className="col-md-6">
						<div className="text-center">
							<img src={ Logo } className="logo" />
						</div>

	                    <p>¿Por qué elegirnos?</p>
                        <ul>
                            <li><strong>Calidad Garantizada:</strong> Nuestro equipo profesional asegura una limpieza impecable.</li>
                            <li><strong>Flexibilidad:</strong> Nos adaptamos a tus horarios y necesidades.</li>
                            <li><strong>Satisfacción:</strong> La satisfacción de nuestros clientes es nuestra prioridad.</li>
                        </ul>

                        <p>No pierdas esta oportunidad de disfrutar de un hogar más limpio y acogedor con la ayuda de nuestros expertos.</p>

                        <div className="text-center row row-stores">
                        	<div className="col-md-6">
                        		<a href={ url_android } target="_blank" className="link-store">
		                        	<img src={ GooglePlay } />
		                        </a>
                        	</div>
	                        <div className="col-md-6">
	                        	<a href={ process.env.REACT_APP_IOS } target="_blank" className="link-store">
		                        	<img src={ AppStore } />
		                        </a>
	                        </div>
	                    </div>

	                    <div className="text-center">
		                    <button onClick={ () => this.next() } className="btn-next">
		                    	<img src={ WebIcon } />
		                    	<p>Sitio Web</p>
		                    </button>
		                </div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Referral);